import {
	createRouter,
	createWebHashHistory
} from 'vue-router'

export const routes = [{
		path: "/login",
		name: 'login',
		meta: {
			notoken: true
		},
		component: () => import('@/views/login/login.vue')
	},
	{
		path: "/password",
		name: 'password',
		meta: {
			notoken: true
		},
		notoken: true,
		component: () => import('@/views/login/password.vue')
	},
	{
		path: "/",
		component: () => import('@/components/navbar.vue'),
		children: [
			{
				path: '/databoard',
				name: 'databoard',
				component: () => import('@/views/databoard.vue'),
				meta: {
					titL: ['数据台'],
					tab: '/databoard',
				},
			},
		]
	},
	{
		path: "/",
		component: () => import('@/components/navbar.vue'),
		children: [
			{
				path: "/store/list",
				name: 'store/list',
				component: () => import('@/views/store/list.vue'),
				meta: {
					titL: ['门店管理'],
					tab: '/store/list',
				},
			},
			{
				path: "/store/add",
				name: 'store/add',
				component: () => import('@/views/store/add.vue'),
				meta: {
					titL: ['新增门店'],
					tab: '/store/list',
				},
			},
		]
	},
	{
		path: "/",
		title: '收支明细',
		component: () => import('@/components/navbar.vue'),
		children: [
			{
				path: "/finance/bill",
				name: 'finance/bill',
				component: () => import('@/views/finance/bill.vue'),
				meta: {
					titL: ['财务明细'],
					tab: '/finance/bill',
				},
			},
			{
				path: "/finance/bill",
				name: 'finance/billId',
				component: () => import('@/views/finance/billId.vue'),
				meta: {
					titL: ['明细详情'],
					tab: '/finance/bill',
				},
			},
		]
	},
	{
		path: "/",
		title: '系统管理',
		component: () => import('@/components/navbar.vue'),
		children: [
			{
				path: "/system/account",
				name: 'system/account',
				component: () => import('@/views/system/account.vue'),
				meta: {
					titL: ['账号信息'],
					tab: '/system/account',
				},
			},
			{
				path: "/system/bind",
				name: 'system/bind',
				component: () => import('@/views/system/bind.vue'),
				meta: {
					titL: ['手机换绑'],
					tab: '/system/account',
				},
			},
			{
				path: "/system/password",
				name: 'system/password',
				component: () => import('@/views/system/password.vue'),
				meta: {
					titL: ['修改密码'],
					tab: '/system/account',
				},
			},
		]
	},
]

const router = createRouter({
	history: createWebHashHistory(),
	routes
})

export default router